import { INTEGRATIONS } from "@/lib/landing/integrations";

/**
 * The auto-scrolling integrations logo rail, shared by the landing arms so
 * every arm lists the same integrations. Runs always — including under
 * prefers-reduced-motion, per explicit product choice carried since the
 * pre-film landing — and pauses on hover. The original copy carries the
 * names; the loop's duplicate copy is aria-hidden. The window is capped at
 * max-w-5xl so the ~6-chip track always overflows it and the duplicate is
 * never visible side by side with the original.
 */
export function IntegrationsMarquee({ className = "" }: { className?: string }) {
  return (
    <div className={`mx-auto max-w-5xl overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)] ${className}`}>
      <div className="flex w-max animate-[sqMarquee_30s_linear_infinite] hover:[animation-play-state:paused]">
        {[false, true].map((clone) => (
          <div
            key={clone ? "clone" : "original"}
            aria-hidden={clone || undefined}
            className="flex items-center gap-3 pr-3"
          >
            {INTEGRATIONS.map((i) => (
              <span
                key={i.name}
                className="flex shrink-0 items-center gap-2.5 whitespace-nowrap rounded-full border border-border-subtle bg-surface-elevated px-4 py-2.5"
              >
                {/* eslint-disable-next-line @next/next/no-img-element -- static vector logo; next/image can't optimize SVG and would require app-wide dangerouslyAllowSVG */}
                <img src={`/logos/${i.file}`} alt="" className="h-6 w-auto" />
                <span className="text-sm font-medium text-foreground">{i.name}</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
